module.exports = __webpack_public_path__ + "a70c006e96c95010b6c609e200e25a91.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/deloitte_2023_chart.png
// module id = 1661
// module chunks = 0